import ClickAndCollect from './ClickAndCollect';

export default ClickAndCollect;
